import { useEffect } from 'react';

import CardBody from 'components/card/CardBody';
import CustomCard from 'components/card/CustomCard';
import CustomCardHeader from 'components/card/CustomCardHeader';
import { SemiTransparentButton } from 'components/CustomButton';
import { useState } from 'react';
import BannerNavBar from '../BannerItemTabs';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { OutlinedButton } from 'components/CustomButton';
import { tabs } from './constants';
import { setSelectedTab } from 'redux/slices/bannerSlices';
import { BannerCreatorModal } from './BannerCreatorModal';
import BannerItemCard from './BannerItemCard';
import CustomModal from 'components/CustomModal';
import { fetchBanners } from 'redux/slices/bannerSlices';
import BannerPreview from "./BannerPreview";
import { useLocation } from 'react-router';

const BannerListTable = () => {
  const [showBanner, setShowBanner] = useState();

  const [previewBanners, setPreviewBanners] = useState(false);
  const [imageToBePreviewed, setImageToBePreviewed] = useState();

  const {
    pages: { loading, error, selectedPage },
    banners: { activeTab, allBannersCount, activeBannersCount, inActiveBannersCount, allBanners, toggle }
  } = useSelector((state) => state.banner);
  const dispatch = useDispatch();
  const location = useLocation()

  useEffect(() => {
    setShowBanner(undefined)
  }, [toggle])

  const fetchBannerListAction = (
    needApiCall,
    isPrev = false
  ) => {
    dispatch(
      fetchBanners({
        apiCall: needApiCall,
        isPrev
      })
    );
    // navigate(`${currentPath}?screen=${screen.value}&tab=${tab.value}&page=${page}`, {replace: true})
  };

  const Tab = ({ bannerCount, tab }) => {
    return (
      <div
        className={`${activeTab === tab
            ? 'bg-secondary-100 text-secondary-500'
            : 'text-rand-200'
          } px-8 py-2.5 text-center hover:bg-gray-100 text-sm font-bold`}
        onClick={() => {
          dispatch(setSelectedTab(tab));
          fetchBannerListAction(false);
        }}
      >
        {tab.label} ({bannerCount})
      </div>
    );
  };


  return (
    <>
      <CustomCard>
        <CustomCardHeader color="lightBlue" contentPosition="none">
          <div className="flex items-center justify-between w-full">
            <h2 className="text-2xl text-white">Banners</h2>
            <SemiTransparentButton onClick={() => setShowBanner({})} disabled={loading}>
              + Add New
            </SemiTransparentButton>
          </div>
        </CustomCardHeader>

        <CardBody>
          <BannerNavBar />
          <div className="flex items-start justify-between space-x-2">
            <div className="inline-flex mb-2 overflow-hidden border cursor-pointer rounded-md">
              <Tab bannerCount={allBannersCount} tab={tabs[0]} />
              <Tab bannerCount={activeBannersCount} tab={tabs[1]} />
              <Tab bannerCount={inActiveBannersCount} tab={tabs[2]} />
            </div>
            <OutlinedButton
              onClick={
                loading || error
                  ? null
                  : () => {
                    setPreviewBanners(true);
                  }
              }
            >
              Preview
            </OutlinedButton>
          </div>
          <BannerItemCard setImageToBePreviewed={setImageToBePreviewed} setUpdateBanner={setShowBanner}
            retry={fetchBannerListAction} />
        </CardBody>
      </CustomCard>

      <BannerCreatorModal
        screen={allBanners.find((d) => d.id === selectedPage)}
        tab={activeTab}
        showModal={!!showBanner}
        setShowModal={() => {
          setShowBanner(undefined);
        }}
        oldData={showBanner?.data}
      />

      <CustomModal title="Preview Banner" showModal={!!imageToBePreviewed} setShowModal={() => setImageToBePreviewed()}>
        <div className="flex justify-center">
          <img src={imageToBePreviewed?.image} alt="images" />
        </div>
      </CustomModal>
      <BannerPreview allBanners={allBanners.filter((all) => all.active_banner !== undefined)}
        previewBanners={previewBanners} setPreviewBanners={setPreviewBanners} />
    </>
  );
};

export default BannerListTable;
